// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xi4P","select":"styles_select__27XJQ"};